<template>
  <img src="@/assets/AddifyLogo_Transparent.png" alt="addify" />
</template>
